import { z } from 'zod';
import { cardSchema } from './card';

export const TURN_STATUSES = ['completed', 'interrupted', 'error'] as const;

export const conversationSummarySchema = z.object({
    id: z.string().min(1),
    title: z.string(),
    createdAt: z.iso.datetime(),
    lastActivityAt: z.iso.datetime(),
});

export const conversationListSchema = z.object({
    page: z.number().int().min(1),
    perPage: z.number().int().min(1),
    total: z.number().int().min(0),
    results: z.array(conversationSummarySchema),
});

export const conversationCallSchema = z.object({
    id: z.string().min(1),
    kpi: z.string().min(1),
    summary: z.string().min(1),
    card: cardSchema.optional(),
    error: z.string().optional(),
});

export const conversationTurnSchema = z.object({
    question: z.string().min(1),
    answer: z
        .object({
            text: z.string(),
            status: z.enum(TURN_STATUSES),
            calls: z.array(conversationCallSchema),
        })
        .nullable(),
});

export const conversationDetailSchema = conversationSummarySchema.extend({
    earlierTurns: z
        .number()
        .int()
        .min(0)
        .describe('How many turns before the first of `turns` are left out.'),
    turns: z.array(conversationTurnSchema),
});

export type TurnStatus = (typeof TURN_STATUSES)[number];
export type ConversationSummary = z.infer<typeof conversationSummarySchema>;
export type ConversationList = z.infer<typeof conversationListSchema>;
export type ConversationCall = z.infer<typeof conversationCallSchema>;
export type ConversationTurn = z.infer<typeof conversationTurnSchema>;
export type ConversationDetail = z.infer<typeof conversationDetailSchema>;
